import {
  ADD_GPT_MSG,
  ADD_GPT_MSG_SUCCESS,
  ADD_GPT_MSG_FAILURE,
  GET_GPT_MSG,
  GET_GPT_MSG_SUCCESS,
  GET_GPT_MSG_FAILURE,
} from "../constants";

const initialState = {
  gptMessages: [],
  isLoading: false,
  isAddLoading: false,
  error: null,
};

export default function GptMessageReducer(state = initialState, action) {
  switch (action.type) {
    case GET_GPT_MSG:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case ADD_GPT_MSG:
      state = {
        ...state,
        isAddLoading: true,
        error: null,
      };
      break;
    case ADD_GPT_MSG_SUCCESS:
      state = {
        ...state,
        isAddLoading: false,
      };
      break;
    case GET_GPT_MSG_SUCCESS:
      state = {
        ...state,
        gptMessages: action.payload,
        isLoading: false,
      };
      break;
    case GET_GPT_MSG_FAILURE:
      state = {
        ...state,
        isLoading: false,
      };
      break;
    case ADD_GPT_MSG_FAILURE:
      state = {
        ...state,
        isAddLoading: false,
      };
      break;
    default:
      break;
  }
  return state;
}
